/* eslint-disable */

import React, { Component } from 'react';
import { Accordion } from 'semantic-ui-react';

import { MediaInstagram } from '../../../components/share';
import NotesQC from './NotesQC';
import './InstagramPosts.css';
import InstagramPostItem from './InstagramPostItem';

class InstagramPosts extends Component {
  state = {
    activeIndex: ''
  };

  handleActiveIndex = (newIndex) => {
    this.setState({ activeIndex: newIndex });
  };

  render() {
    const { activeIndex } = this.state;

    return (
      <div>
        <Accordion styled className="instagram-posts">
          {this.props.posts.map((post, i) => (
            <InstagramPostItem
              key={i}
              post={post}
              user={this.props.user}
              updateActiveIndex={this.handleActiveIndex}
              activeIndex={this.state.activeIndex}
              index={i}
              subStr={this.props.subStr}
            />
          ))}
        </Accordion>
      </div>
    );
  }
}

export default InstagramPosts;



// WEBPACK FOOTER //
// ./src/screens/Compliance/components/InstagramPosts.js